"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var conversions = require("webidl-conversions");
var utils = require("./utils.js");
var DocumentType = require("./DocumentType.js");
var implSymbol = utils.implSymbol;
var ctorRegistrySymbol = utils.ctorRegistrySymbol;
var interfaceName = "DOMImplementation";
exports.is = function (value) {
  return utils.isObject(value) && utils.hasOwn(value, implSymbol) && value[implSymbol] instanceof Impl.implementation;
};
exports.isImpl = function (value) {
  return utils.isObject(value) && value instanceof Impl.implementation;
};
exports.convert = function (globalObject, value) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$context = _ref.context,
    context = _ref$context === void 0 ? "The provided value" : _ref$context;
  if (exports.is(value)) {
    return utils.implForWrapper(value);
  }
  throw new globalObject.TypeError("".concat(context, " is not of type 'DOMImplementation'."));
};
function makeWrapper(globalObject, newTarget) {
  var proto;
  if (newTarget !== undefined) {
    proto = newTarget.prototype;
  }
  if (!utils.isObject(proto)) {
    proto = globalObject[ctorRegistrySymbol]["DOMImplementation"].prototype;
  }
  return Object.create(proto);
}
exports.create = function (globalObject, constructorArgs, privateData) {
  var wrapper = makeWrapper(globalObject);
  return exports.setup(wrapper, globalObject, constructorArgs, privateData);
};
exports.createImpl = function (globalObject, constructorArgs, privateData) {
  var wrapper = exports.create(globalObject, constructorArgs, privateData);
  return utils.implForWrapper(wrapper);
};
exports._internalSetup = function (wrapper, globalObject) {};
exports.setup = function (wrapper, globalObject) {
  var constructorArgs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var privateData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  privateData.wrapper = wrapper;
  exports._internalSetup(wrapper, globalObject);
  Object.defineProperty(wrapper, implSymbol, {
    value: new Impl.implementation(globalObject, constructorArgs, privateData),
    configurable: true
  });
  wrapper[implSymbol][utils.wrapperSymbol] = wrapper;
  if (Impl.init) {
    Impl.init(wrapper[implSymbol]);
  }
  return wrapper;
};
exports["new"] = function (globalObject, newTarget) {
  var wrapper = makeWrapper(globalObject, newTarget);
  exports._internalSetup(wrapper, globalObject);
  Object.defineProperty(wrapper, implSymbol, {
    value: Object.create(Impl.implementation.prototype),
    configurable: true
  });
  wrapper[implSymbol][utils.wrapperSymbol] = wrapper;
  if (Impl.init) {
    Impl.init(wrapper[implSymbol]);
  }
  return wrapper[implSymbol];
};
var exposed = new Set(["Window"]);
exports.install = function (globalObject, globalNames) {
  if (!globalNames.some(function (globalName) {
    return exposed.has(globalName);
  })) {
    return;
  }
  var ctorRegistry = utils.initCtorRegistry(globalObject);
  var DOMImplementation = /*#__PURE__*/function () {
    function DOMImplementation() {
      _classCallCheck(this, DOMImplementation);
      throw new globalObject.TypeError("Illegal constructor");
    }
    _createClass(DOMImplementation, [{
      key: "createDocumentType",
      value: function createDocumentType(qualifiedName, publicId, systemId) {
        var _esValue$implSymbol;
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'createDocumentType' called on an object that is not a valid instance of DOMImplementation.");
        }
        if (arguments.length < 3) {
          throw new globalObject.TypeError("Failed to execute 'createDocumentType' on 'DOMImplementation': 3 arguments required, but only ".concat(arguments.length, " present."));
        }
        var args = [];
        {
          var curArg = arguments[0];
          curArg = conversions["DOMString"](curArg, {
            context: "Failed to execute 'createDocumentType' on 'DOMImplementation': parameter 1",
            globals: globalObject
          });
          args.push(curArg);
        }
        {
          var _curArg = arguments[1];
          _curArg = conversions["DOMString"](_curArg, {
            context: "Failed to execute 'createDocumentType' on 'DOMImplementation': parameter 2",
            globals: globalObject
          });
          args.push(_curArg);
        }
        {
          var _curArg2 = arguments[2];
          _curArg2 = conversions["DOMString"](_curArg2, {
            context: "Failed to execute 'createDocumentType' on 'DOMImplementation': parameter 3",
            globals: globalObject
          });
          args.push(_curArg2);
        }
        return utils.tryWrapperForImpl((_esValue$implSymbol = esValue[implSymbol]).createDocumentType.apply(_esValue$implSymbol, args));
      }
    }, {
      key: "createDocument",
      value: function createDocument(namespace, qualifiedName) {
        var _esValue$implSymbol2;
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'createDocument' called on an object that is not a valid instance of DOMImplementation.");
        }
        if (arguments.length < 2) {
          throw new globalObject.TypeError("Failed to execute 'createDocument' on 'DOMImplementation': 2 arguments required, but only ".concat(arguments.length, " present."));
        }
        var args = [];
        {
          var curArg = arguments[0];
          if (curArg === null || curArg === undefined) {
            curArg = null;
          } else {
            curArg = conversions["DOMString"](curArg, {
              context: "Failed to execute 'createDocument' on 'DOMImplementation': parameter 1",
              globals: globalObject
            });
          }
          args.push(curArg);
        }
        {
          var _curArg3 = arguments[1];
          _curArg3 = conversions["DOMString"](_curArg3, {
            context: "Failed to execute 'createDocument' on 'DOMImplementation': parameter 2",
            globals: globalObject,
            treatNullAsEmptyString: true
          });
          args.push(_curArg3);
        }
        {
          var _curArg4 = arguments[2];
          if (_curArg4 !== undefined) {
            if (_curArg4 === null || _curArg4 === undefined) {
              _curArg4 = null;
            } else {
              _curArg4 = DocumentType.convert(globalObject, _curArg4, {
                context: "Failed to execute 'createDocument' on 'DOMImplementation': parameter 3"
              });
            }
          } else {
            _curArg4 = null;
          }
          args.push(_curArg4);
        }
        return utils.tryWrapperForImpl((_esValue$implSymbol2 = esValue[implSymbol]).createDocument.apply(_esValue$implSymbol2, args));
      }
    }, {
      key: "createHTMLDocument",
      value: function createHTMLDocument() {
        var _esValue$implSymbol3;
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'createHTMLDocument' called on an object that is not a valid instance of DOMImplementation.");
        }
        var args = [];
        {
          var curArg = arguments[0];
          if (curArg !== undefined) {
            curArg = conversions["DOMString"](curArg, {
              context: "Failed to execute 'createHTMLDocument' on 'DOMImplementation': parameter 1",
              globals: globalObject
            });
          }
          args.push(curArg);
        }
        return utils.tryWrapperForImpl((_esValue$implSymbol3 = esValue[implSymbol]).createHTMLDocument.apply(_esValue$implSymbol3, args));
      }
    }, {
      key: "hasFeature",
      value: function hasFeature() {
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'hasFeature' called on an object that is not a valid instance of DOMImplementation.");
        }
        return esValue[implSymbol].hasFeature();
      }
    }]);
    return DOMImplementation;
  }();
  Object.defineProperties(DOMImplementation.prototype, _defineProperty({
    createDocumentType: {
      enumerable: true
    },
    createDocument: {
      enumerable: true
    },
    createHTMLDocument: {
      enumerable: true
    },
    hasFeature: {
      enumerable: true
    }
  }, Symbol.toStringTag, {
    value: "DOMImplementation",
    configurable: true
  }));
  ctorRegistry[interfaceName] = DOMImplementation;
  Object.defineProperty(globalObject, interfaceName, {
    configurable: true,
    writable: true,
    value: DOMImplementation
  });
};
var Impl = require("../nodes/DOMImplementation-impl.js");